import { c as _c } from "react/compiler-runtime";
import { MapItemWithCoodId } from "@/types/search";
import React from "react";
import { GenericProjectsList } from "./generic-projects-list";
interface MatchingProjectsListProps {
  projectData: MapItemWithCoodId[];
  locationName: string | null;
  columnsCount: number;
  locationPropertyCount?: number;
}
export const MatchingProjectsList = React.memo(function MatchingProjectsList(t0) {
  const $ = _c(7);
  const {
    projectData,
    locationName,
    columnsCount,
    locationPropertyCount
  } = t0;
  let t1;
  if ($[0] !== locationName || $[1] !== locationPropertyCount) {
    t1 = t2 => {
      const {
        count
      } = t2;
      const displayCount = locationName ? locationPropertyCount ?? 0 : count;
      if (displayCount > 0 && locationName) {
        const propertyText = displayCount === 1 ? "property" : "properties";
        return {
          text: `${displayCount} ${propertyText} in ${locationName}`,
          icon: <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
        };
      }
      return null;
    };
    $[0] = locationName;
    $[1] = locationPropertyCount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const headerContent = t1;
  let t2;
  if ($[3] !== columnsCount || $[4] !== headerContent || $[5] !== projectData) {
    t2 = <GenericProjectsList projectData={projectData} columnsCount={columnsCount} headerContent={headerContent} />;
    $[3] = columnsCount;
    $[4] = headerContent;
    $[5] = projectData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
});